import { IFolderInfo, IFileInFolderInfo } from 'isogd-file-rest';
import { OrderDocumentResult } from 'orders-rest';
import * as _ from 'lodash';
import * as angular from 'angular';

class ResultsController {
    private _result: OrderDocumentResult[];
    private result: OrderDocumentResult[];
    private folderInfo: IFolderInfo;

    $onInit() {
        this._result = angular.copy(this.result);
    }

    getFileByIds(ids: string[]): IFileInFolderInfo[] {
        return _.filter(this.folderInfo.files, f => { return _.findIndex(ids, i => { return i === f.versionSeriesGuid; }) !== -1; });
    }
}

export const  ResultsComponent: angular.IComponentOptions = {
    controller:  ResultsController,
    template: require('./results.html'),
    bindings: {
        result: '<',
        folderInfo: '<'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/result/results.ts